( ( d ) => {
	const attr = {
		btnControl: 'data-control',
		indexOffset: 'data-index-offset',
		ofiSrc: 'data-ofi-src',
	}
	const className = {
		inactive: 'inactive',
	}
	const confDefault = {
		speed: 1,
		swipeMin: 50,
	}
	const selector = {
		btnControl: `[${attr.btnControl}]`,
		conf: 'script[type = "application/json"]',
		container: '.post-gallery',
		controls: '.controls',
		slides: '.slides',
	}

	// centres visible slides
	const align = ( confAll, slides, init ) => {
		slides.removeAttribute( 'style' )
		const visible = slidesVisible( confAll, slides )
		const width = slides.firstElementChild.offsetWidth
		const offset = -( width - ( d.documentElement.clientWidth / 2 - ( width * visible ) / 2 - slides.offsetLeft ) )
		slides.setAttribute( 'style', `left:${offset}px` )
		slides.setAttribute( attr.indexOffset, Math.ceil( -offset / width ) )
		move( confAll, slides, -1, init ? Math.ceil( -offset / width ) : 0, false )
	}

	// resets img src's (object-fit-images polyfill doesn't check for it's own work)
	const clean = html => {
		const el = document.createElement( 'div' )
		el.innerHTML = html
		nodes( el.querySelectorAll( `[${attr.ofiSrc}]` ) ).forEach( _ =>
			_.setAttribute( 'src', _.getAttribute( attr.ofiSrc ) ) )
		return el.firstElementChild
	}

	// gets config for current window width
	const currentConf = ( conf, defaults = true ) => {
		const out = {}
		const merge = ( target, ...updates ) =>
			updates.reduce( ( acc, _ ) => {
				Object.keys( _ ).forEach( k => acc[ k ] = _[ k ] )
				return acc
			}, target )
		Object.keys( conf.breakpoint || {} ).forEach( n => {
			if ( d.documentElement.clientWidth >= n ) {
				merge( out, conf.breakpoint[ n ] )
			}
		} )
		return merge( {}, defaults ? confDefault : {}, out )
	}

	const init = el => {
		const conf = JSON.parse( el.querySelector( selector.conf ).innerHTML || 'null' )
		const controls = el.querySelector( selector.controls )
		const slides = el.querySelector( selector.slides )

		// listen for clicks
		nodes( controls.querySelectorAll( selector.btnControl ) ).forEach( _ =>
			_.addEventListener( 'click', move.bind( this, conf, slides, _.getAttribute( attr.btnControl ), undefined, true ) ) )

		// listen for swipes
		el.addEventListener( 'touchstart', touch.bind( this, conf, slides ) )

		// align
		align( conf, slides, true )
		window.addEventListener( 'resize', align.bind( this, conf, slides, false ) )
	}

	const move = ( confAll, slides, dir, n, anim ) => {
		if ( slides.active ) return
		const conf = currentConf( confAll )
		const visible = slidesVisible( confAll, slides )
		const step = n !== undefined ? n : conf.step || visible
		const distance = slides.children[ 0 ].offsetWidth * dir * step
		const reverse = dir < 0

		// clone slides
		const clones = []
		for ( let i = 0; i < step; i += 1 ) {
			slides.insertAdjacentElement(
				reverse ? 'afterbegin' : 'beforeend',
				clean( slides.children[ reverse ? slides.children.length - 1 - i : i ].outerHTML ) )
			clones.push( slides.children[ reverse ? slides.children.length - 1 - i : i ] )
		}

		// set states
		const indexOffset = +slides.getAttribute( attr.indexOffset )
		nodes( slides.children ).forEach( ( _, i ) => {
			_.classList.add( className.inactive )
			_.querySelector( 'a' ).setAttribute( 'tabindex', '-1' )
			if ( ( reverse && i >= indexOffset && i < indexOffset + visible )
				|| ( !reverse && i >= step + indexOffset && i < step + indexOffset + visible ) ) {
				_.classList.remove( className.inactive )
				_.querySelector( 'a' ).removeAttribute( 'tabindex' )
			} } )

		// move by setting margin of left-most slide
		slides.firstElementChild.setAttribute( 'style', `margin-left:${reverse ? distance : 0}px` )
		setTimeout( () => slides.firstElementChild.setAttribute(
			'style',
			`margin-left:${reverse ? 0 : -distance}px;transition:margin ${anim ? conf.speed : 0}s` ) )

		// tidy up
		slides.active = true
		setTimeout( () => {
			slides.active = false
			slides.firstElementChild.removeAttribute( 'style' )
			clones.forEach( _ => slides.removeChild( _ ) )
		}, anim ? conf.speed * 1000 : 0 )
	}

	// converts nodelist to array
	const nodes = _ => Array.prototype.slice.apply( _ )

	const slidesVisible = ( confAll, slides ) =>
		currentConf( confAll ).show || Math.floor( 1 / ( slides.firstElementChild.offsetWidth / d.documentElement.clientWidth ) )

	// moves when swiped horizontally
	const touch = ( confAll, slides, e ) => {
		const end = ( _ => {
			const delta = {
				x: e.touches[ 0 ].screenX - _.changedTouches[ 0 ].screenX,
				y: e.touches[ 0 ].screenY - _.changedTouches[ 0 ].screenY }

			if ( Math.abs( delta.x ) > currentConf( confAll ).swipeMin
				&& Math.abs( delta.x ) > Math.abs( delta.y ) ) {
				move( confAll, slides, Math.sign( delta.x ), undefined, true )
			}

			document.removeEventListener( 'touchend', end )
		} ).bind( this )

		document.addEventListener( 'touchend', end )
	}

	d.addEventListener( 'DOMContentLoaded', () =>
		nodes( d.body.querySelectorAll( selector.container ) ).forEach( init ) )

} )( document )
